import { ExclamationOutlined, SearchOutlined } from '@ant-design/icons';

interface IEvidenceSectionCompletedIconProps {
  hasFailedReview?: boolean;
  isUnderReview?: boolean;
  taskCompleted?: boolean;
}

export const EvidenceSectionCompletedIcon = ({
  hasFailedReview,
  isUnderReview,
  taskCompleted,
}: IEvidenceSectionCompletedIconProps) => {
  if (hasFailedReview && !taskCompleted) {
    return (
      <div className='flex size-10 shrink-0 items-center justify-center rounded-full bg-red-500 p-2 text-base font-bold leading-none text-white'>
        <ExclamationOutlined />
      </div>
    );
  }

  if (isUnderReview) {
    return (
      <div className='flex size-10 shrink-0 items-center justify-center rounded-full bg-gray-400 p-2 text-base font-bold leading-none text-white'>
        <SearchOutlined />
      </div>
    );
  }

  return (
    <div className='flex size-10 shrink-0 items-center justify-center rounded-full bg-green-500 p-2 text-base font-bold leading-none text-white'>
      ✓
    </div>
  );
};
